import {
	Box,
	Button,
	Typography,
	Autocomplete,
	TextField,
	Alert,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Divider,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import DownloadIcon from "@mui/icons-material/Download";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AuthContext } from "context";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";
import GenericTable from "../genericTable";
import StatusIndicator from "./StatusIndicator";
import { buildObliqueColumnMeta, getNonObliqueHeadCellSx } from "../../utils/tableColumnUtils";

const JOURNAL_HEADER_HEIGHT = 300;
const NON_OBLIQUE_HEAD_CELL_SX = getNonObliqueHeadCellSx(JOURNAL_HEADER_HEIGHT);

function ManagementSecuritySupplierUser() {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [personnelDocuments, setPersonnelDocuments] = useState([]);
	const [loadingPersonnel, setLoadingPersonnel] = useState(false);
	const [isSecurityManager, setIsSecurityManager] = useState(false);
	const [availableSuppliers, setAvailableSuppliers] = useState([]);
	const [selectedSupplier, setSelectedSupplier] = useState(null);
	const [loadingSuppliers, setLoadingSuppliers] = useState(false);
	const [downloadingZip, setDownloadingZip] = useState(false);
	const personnelColumnHelper = createMRTColumnHelper();
	const [personnelColumns, setpersonnelColumns] = useState([]);

	// Download dialog state
	const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
	const [availableDocTypes, setAvailableDocTypes] = useState([]); // [{id: "general_5", name: "Doc Name"}, ...]
	const [selectedDocTypes, setSelectedDocTypes] = useState([]); // ["general_5", "general_6", ...]
	const [selectedOperators, setSelectedOperators] = useState({}); // {userId: {selected: true, documents: ["general_5", ...]}}
	const [expandedOperator, setExpandedOperator] = useState(null);

	// Helper to extract numeric key from document type ID (e.g., "general_5" -> "5")
	const getStatusKey = (docTypeId) => docTypeId.replace("general_", "");
	const initialPersonnelColumns = [
		personnelColumnHelper.accessor("action", {
			header: "Azioni",
			size: 100,
			enableColumnFilter: false,
			muiTableHeadCellProps: { sx: NON_OBLIQUE_HEAD_CELL_SX },
			Cell: ({ row }) =>
				authContext?.hasAuth(`UPSERT_DOCUMENTS_SUPPLIER`) && (
					<Button
						variant="contained"
						size="small"
						onClick={() => navigate(`/security-document-upload/user/${row.original.name}/${row.original.id}/`)}
						sx={{
							marginTop: "10px",
							marginBottom: "30px",
							backgroundColor: "#514f4f",
							color: "white!important",
							mb: 2,
							width: "120px",
							height: "40px",
							fontSize: "10px",
							display: "flex",
							alignItems: "center",
							boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
							justifyContent: "center",
							borderColor: "black",
							gap: "8px",
							"&:hover": {
								backgroundColor: "#514f4f",
								boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
								color: "white!important",
							},
							"&:focus": {
								backgroundColor: "#514f4f",
								boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
								color: "white!important",
							},
							"&:active": {
								backgroundColor: "#514f4f",
								boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
								color: "white!important",
							},
						}}
					>
						Gestisci Documenti
					</Button>
				),
		}),
		personnelColumnHelper.accessor("name", {
			header: "Operatore",
			size: 120,
			muiTableHeadCellProps: { sx: NON_OBLIQUE_HEAD_CELL_SX },
		}),
		/*personnelColumnHelper.accessor('last_name', {
  header: 'Cognome',
  size: 120,
}),*/
		/*personnelColumnHelper.accessor('allow_access', {
  header: 'Abilita ingresso in cantiere',
  size: 120,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    ( authContext?.hasAuth(`UPSERT_SECURITY_MANAGMENT`) ?
        ( (cell.row?.original?.documents_required_not_uploaded == 0 && cell.row?.original?.documents_rejected == 0) &&
          <Checkbox
              checked={cell.row?.original?.allow_access}
              onChange={(event, value) => {

                handleCheckboxChange(cell.row.original.id, value);
              }}
              sx={{
                  transform: "scale(1.5)", // Ingrandisce la Checkbox di 1.5 volte
                  '& .MuiSvgIcon-root': { fontSize: 28 } // Ingrandisce l'icona all'interno della Checkbox
              }}
          />
        )
    :
    <Typography variant={"body2"}>
      {cell.getValue() ? 'Abilitato' : 'Disabilitato'}
    </Typography>
    )
  ),
}),
personnelColumnHelper.accessor('documents_required_uploaded', {
  header: 'Doc. Necessari Caricati',
  size: 100,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    <Typography >
      {cell.getValue()}
    </Typography>
  ),

}),
personnelColumnHelper.accessor('documents_required_not_uploaded', {
  header: 'Doc. Necessari Non Caricati',
  size: 100,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    <Typography color={parseInt(cell.getValue()) > 0 ? 'error' : 'inherit'}>
      {cell.getValue()}
    </Typography>
  ),
}),
personnelColumnHelper.accessor('documents_not_required_uploaded', {
  header: 'Doc. Opzionali Caricati',
  size: 100,
}),
personnelColumnHelper.accessor('documents_not_required_not_uploaded', {
  header: 'Doc. Opzionali Non Caricati',
  size: 100,
}),
personnelColumnHelper.accessor('documents_approved', {
  header: 'Doc. Approvati',
  enableColumnFilter: false,
  size: 100,
  Cell: ({ cell }) => (
    <Typography>
      {cell.getValue()}
    </Typography>
  ),
}),
personnelColumnHelper.accessor('documents_rejected', {
  header: 'Doc. Rifiutati',
  size: 100,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    <Typography color={parseInt(cell.getValue()) > 0 ? 'error' : 'inherit'}>
      {cell.getValue()}
    </Typography>
  ),
}),*/
	];

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	function fetchAuthorizedSuppliers() {
		setLoadingSuppliers(true);

		apiService
			.get("/suppliers-management", { get_authorized_suppliers: true }, {})
			.then((response) => {
				if (response) {
					setAvailableSuppliers(response);
					setLoadingSuppliers(false);
				}
			})
			.catch((error) => {
				handleSetNotification("Errore durante il caricamento dei fornitori", "error");
				setLoadingSuppliers(false);
			});
	}

	function fetchPersonnelDocument(supplierId = null) {
		setLoadingPersonnel(true);

		const supplierIdToUse = supplierId || localStorage.getItem("supplier");

		apiService
			.get("/get-documents", { supplier_id: supplierIdToUse, is_summary: true }, {})
			.then((response) => {
				if (response) {
					setPersonnelDocuments(response["userData"]);
					const new_columns = [...initialPersonnelColumns];
					const columns_to_add = response["columns"];

					// Save document types for download dialog (prefix with "general_" for backend filter)
					const docTypes = columns_to_add.map((column) => {
						const columnKey = Object.keys(column)[0];
						const columnName = column[columnKey];
						return { id: `general_${columnKey}`, name: columnName };
					});
					setAvailableDocTypes(docTypes);

					columns_to_add.forEach((column) => {
						const columnKey = Object.keys(column)[0]; // Prendi la chiave dell'oggetto (ID del documento)
						const columnName = column[columnKey]; // Prendi il valore (nome del documento)

						new_columns.push(
							personnelColumnHelper.accessor(columnKey, {
								...buildObliqueColumnMeta(columnName, 85, {
									headerHeight: JOURNAL_HEADER_HEIGHT,
									rotationAngle: -80,
									contentLabelsPaddingLeft: "3rem",
									contentWrapperDisplay: "inline-flex",
								}),
								Cell: ({ cell }) => (
									<Typography>
										<StatusIndicator status={cell.getValue()} />
									</Typography>
								),
							})
						);
					});

					setpersonnelColumns([...new_columns]);
					setLoadingPersonnel(false);
				}
			})
			.catch((error) => {
				handleSetNotification("Errore durante la chiamata al server, codice d'errore #08514262429906", "error");
				setLoadingPersonnel(false);
			});
	}

	const handleSupplierChange = (event, newValue) => {
		setSelectedSupplier(newValue);
		if (newValue) {
			// Salva in sessionStorage per mantenerlo durante la navigazione
			sessionStorage.setItem("selectedSupplier", JSON.stringify(newValue));
			fetchPersonnelDocument(newValue.id);
		} else {
			sessionStorage.removeItem("selectedSupplier");
			setPersonnelDocuments([]);
			setpersonnelColumns([]);
		}
	};

	// Get operators that have at least one uploaded document
	const operatorsWithDocuments = useMemo(() => {
		return personnelDocuments.filter((operator) => {
			return availableDocTypes.some((docType) => {
				const status = operator[getStatusKey(docType.id)];
				return status && status !== "toUpload";
			});
		});
	}, [personnelDocuments, availableDocTypes]);

	// Open dialog and initialize selections
	const handleOpenDownloadDialog = () => {
		// Initialize all document types as selected
		setSelectedDocTypes(availableDocTypes.map((dt) => dt.id));

		// Initialize all operators with all their available documents selected
		const operatorSelections = {};
		operatorsWithDocuments.forEach((operator) => {
			const availableDocs = availableDocTypes
				.filter((docType) => {
					const status = operator[getStatusKey(docType.id)];
					return status && status !== "toUpload";
				})
				.map((dt) => dt.id);

			operatorSelections[operator.id] = {
				selected: availableDocs.length > 0,
				documents: availableDocs,
			};
		});
		setSelectedOperators(operatorSelections);
		setExpandedOperator(null);
		setDownloadDialogOpen(true);
	};

	// Toggle all document types
	const handleToggleAllDocTypes = (checked) => {
		if (checked) {
			setSelectedDocTypes(availableDocTypes.map((dt) => dt.id));
			// Also add these docs to all operators
			setSelectedOperators((prev) => {
				const updated = { ...prev };
				Object.keys(updated).forEach((opId) => {
					const operator = operatorsWithDocuments.find((o) => o.id.toString() === opId);
					if (operator) {
						const availableDocs = availableDocTypes
							.filter((docType) => {
								const status = operator[getStatusKey(docType.id)];
								return status && status !== "toUpload";
							})
							.map((dt) => dt.id);
						updated[opId] = { ...updated[opId], documents: availableDocs, selected: availableDocs.length > 0 };
					}
				});
				return updated;
			});
		} else {
			setSelectedDocTypes([]);
			// Remove all docs from all operators
			setSelectedOperators((prev) => {
				const updated = { ...prev };
				Object.keys(updated).forEach((opId) => {
					updated[opId] = { ...updated[opId], documents: [], selected: false };
				});
				return updated;
			});
		}
	};

	// Toggle single document type globally
	const handleToggleDocType = (docTypeId, checked) => {
		if (checked) {
			setSelectedDocTypes((prev) => [...prev, docTypeId]);
			// Add to all operators who have this doc
			setSelectedOperators((prev) => {
				const updated = { ...prev };
				Object.keys(updated).forEach((opId) => {
					const operator = operatorsWithDocuments.find((o) => o.id.toString() === opId);
					if (operator) {
						const status = operator[getStatusKey(docTypeId)];
						if (status && status !== "toUpload" && !updated[opId].documents.includes(docTypeId)) {
							updated[opId] = {
								...updated[opId],
								documents: [...updated[opId].documents, docTypeId],
								selected: true,
							};
						}
					}
				});
				return updated;
			});
		} else {
			setSelectedDocTypes((prev) => prev.filter((id) => id !== docTypeId));
			// Remove from all operators
			setSelectedOperators((prev) => {
				const updated = { ...prev };
				Object.keys(updated).forEach((opId) => {
					const newDocs = updated[opId].documents.filter((id) => id !== docTypeId);
					updated[opId] = {
						...updated[opId],
						documents: newDocs,
						selected: newDocs.length > 0,
					};
				});
				return updated;
			});
		}
	};

	// Toggle all operators
	const handleToggleAllOperators = (checked) => {
		setSelectedOperators((prev) => {
			const updated = { ...prev };
			Object.keys(updated).forEach((opId) => {
				if (checked) {
					const operator = operatorsWithDocuments.find((o) => o.id.toString() === opId);
					if (operator) {
						const availableDocs = availableDocTypes
							.filter((docType) => {
								const status = operator[getStatusKey(docType.id)];
								return status && status !== "toUpload" && selectedDocTypes.includes(docType.id);
							})
							.map((dt) => dt.id);
						updated[opId] = { selected: availableDocs.length > 0, documents: availableDocs };
					}
				} else {
					updated[opId] = { selected: false, documents: [] };
				}
			});
			return updated;
		});
	};

	// Toggle single operator (all their docs)
	const handleToggleOperator = (operatorId, checked) => {
		setSelectedOperators((prev) => {
			const operator = operatorsWithDocuments.find((o) => o.id.toString() === operatorId);
			if (!operator) return prev;

			if (checked) {
				const availableDocs = availableDocTypes
					.filter((docType) => {
						const status = operator[getStatusKey(docType.id)];
						return status && status !== "toUpload" && selectedDocTypes.includes(docType.id);
					})
					.map((dt) => dt.id);
				return {
					...prev,
					[operatorId]: { selected: availableDocs.length > 0, documents: availableDocs },
				};
			} else {
				return {
					...prev,
					[operatorId]: { selected: false, documents: [] },
				};
			}
		});
	};

	// Toggle single document for a specific operator
	const handleToggleOperatorDoc = (operatorId, docTypeId, checked) => {
		setSelectedOperators((prev) => {
			const current = prev[operatorId] || { selected: false, documents: [] };
			let newDocs;
			if (checked) {
				newDocs = [...current.documents, docTypeId];
			} else {
				newDocs = current.documents.filter((id) => id !== docTypeId);
			}
			return {
				...prev,
				[operatorId]: {
					selected: newDocs.length > 0,
					documents: newDocs,
				},
			};
		});
	};

	// Count total selected documents
	const totalSelectedDocs = useMemo(() => {
		return Object.values(selectedOperators).reduce((sum, op) => sum + op.documents.length, 0);
	}, [selectedOperators]);

	// Download with selection via POST
	const handleDownloadWithSelection = async () => {
		const supplierId = isSecurityManager ? selectedSupplier?.id : localStorage.getItem("supplier");
		if (!supplierId) {
			showToast("Seleziona prima un fornitore", "error");
			return;
		}

		const selectedUserIds = Object.entries(selectedOperators)
			.filter(([_, data]) => data.selected && data.documents.length > 0)
			.map(([userId]) => parseInt(userId));

		if (selectedUserIds.length === 0) {
			showToast("Seleziona almeno un operatore con documenti", "error");
			return;
		}

		// Collect all unique document IDs across selected operators
		const allSelectedDocIds = new Set();
		Object.entries(selectedOperators).forEach(([_, data]) => {
			if (data.selected) {
				data.documents.forEach((docId) => allSelectedDocIds.add(docId));
			}
		});

		setDownloadDialogOpen(false);
		setDownloadingZip(true);

		try {
			const token = localStorage.getItem("token");
			const baseUrl =
				window.location.hostname.split(".")[0] !== "localhost"
					? `${window.location.protocol}//${window.location.hostname}/api`
					: process.env.REACT_APP_API_URL_BACKEND;

			const payload = {
				download_type: "supplier_user",
				supplier_id: supplierId,
				user_ids: selectedUserIds,
				document_ids: Array.from(allSelectedDocIds),
			};

			const response = await fetch(`${baseUrl}/download-security-documents-zip/`, {
				method: "POST",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
				credentials: "include",
				body: JSON.stringify(payload),
			});

			if (!response.ok) {
				const errorData = await response.json().catch(() => ({}));
				throw new Error(errorData.error || "Download failed");
			}

			const contentDisposition = response.headers.get("Content-Disposition");
			let filename = "documenti_operatori.zip";
			if (contentDisposition) {
				const match = contentDisposition.match(/filename="(.+)"/);
				if (match) filename = match[1];
			}

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);

			showToast("Download completato", "success");
		} catch (error) {
			showToast(error.message || "Errore durante il download", "error");
			console.error("Download error:", error);
		}
		setDownloadingZip(false);
	};

	useEffect(() => {
		const supplierIdInLocalStorage = localStorage.getItem("supplier");

		if (authContext?.hasAuth("VIEW_DOCUMENTS_SUPPLIER") && !supplierIdInLocalStorage) {
			// È un security manager interno
			setIsSecurityManager(true);
			fetchAuthorizedSuppliers();
		} else {
			// È un supplier worker, carica i documenti del proprio fornitore
			setIsSecurityManager(false);
			fetchPersonnelDocument();
		}
	}, []);

	return (
		<>
			<DashboardLayout>
				{authContext.hasAuth("VIEW_DOCUMENTS_SUPPLIER") ? (
					<>
						<DashboardNavbar></DashboardNavbar>
						<Box sx={{ p: 3 }}>
							<MDBox style={{ width: "100%", marginTop: "20px" }}>
								<center>
									<Typography variant="h5" gutterBottom>
										DOCUMENTI PERSONALE
									</Typography>

									{/* Dropdown per selezione fornitore - solo per security manager */}
									{isSecurityManager && (
										<Box sx={{ maxWidth: 500, margin: "20px auto" }}>
											{loadingSuppliers ? (
												<CircularProgress size={40} />
											) : (
												<>
													<Autocomplete
														value={selectedSupplier}
														onChange={handleSupplierChange}
														options={availableSuppliers}
														getOptionLabel={(option) => option.name}
														renderInput={(params) => (
															<TextField
																{...params}
																label="Seleziona Fornitore"
																placeholder="Cerca fornitore..."
															/>
														)}
														renderOption={(props, option) => (
															<Box component="li" {...props}>
																<Box>
																	<Typography variant="body1">{option.name}</Typography>
																	<Typography variant="caption" color="text.secondary">
																		{option.areas?.length > 0
																			? `Aree: ${option.areas.map((a) => a.name).join(", ")}`
																			: "Nessuna area assegnata"}
																	</Typography>
																</Box>
															</Box>
														)}
														noOptionsText="Nessun fornitore disponibile"
													/>
													{selectedSupplier && (
														<Alert severity="info" sx={{ mt: 2 }}>
															Visualizzazione documenti operatori di <strong>{selectedSupplier.name}</strong>
														</Alert>
													)}
												</>
											)}
										</Box>
									)}
									{!loadingPersonnel && personnelDocuments.length > 0 && (!isSecurityManager || selectedSupplier) && (
										<Button
											variant="contained"
											onClick={handleOpenDownloadDialog}
											disabled={downloadingZip}
											startIcon={downloadingZip ? <CircularProgress size={20} color="inherit" /> : <DownloadIcon />}
											sx={{
												marginTop: "10px",
												marginBottom: "30px",
												backgroundColor: "#514f4f",
												color: "white!important",
												mb: 2,
												width: "280px",
												height: "50px",
												fontSize: "14px",
												display: "flex",
												alignItems: "center",
												boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
												justifyContent: "center",
												gap: "8px",
												"&:hover": {
													backgroundColor: "#3d3b3b",
													boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
													color: "white!important",
												},
												"&:disabled": {
													backgroundColor: "#7a7777",
													color: "rgba(255,255,255,0.7)!important",
												},
											}}
										>
											{downloadingZip ? "Download in corso..." : "Scarica Documenti Operatori"}
										</Button>
									)}
								</center>
								{!loadingPersonnel && personnelColumns.length > 0 && (!isSecurityManager || selectedSupplier) ? (
									<GenericTable
										key={personnelColumns?.length}
										data={personnelDocuments}
										columns={personnelColumns}
										enableRowSelection={false}
									/>
								) : loadingPersonnel ? (
									<center>
										<CircularProgress size={120} sx={{ marginTop: "250px", color: "#2b84ea" }} />
									</center>
								) : isSecurityManager && !selectedSupplier ? (
									<Alert severity="info" sx={{ mt: 4 }}>
										Seleziona un fornitore per visualizzare i documenti degli operatori
									</Alert>
								) : null}
							</MDBox>
						</Box>
					</>
				) : (
					<MDBox mt={8}>
						<MDAlert color="error">Non hai i permessi per visualizzare questa pagina</MDAlert>
					</MDBox>
				)}

				{/* Download Selection Dialog */}
				<Dialog
					open={downloadDialogOpen}
					onClose={() => setDownloadDialogOpen(false)}
					maxWidth="md"
					fullWidth
					PaperProps={{ sx: { maxHeight: "80vh" } }}
				>
					<DialogTitle sx={{ borderBottom: "1px solid #e0e0e0" }}>Seleziona Documenti da Scaricare</DialogTitle>
					<DialogContent sx={{ p: 0 }}>
						{/* Document Types Section */}
						<Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
							<Accordion
								defaultExpanded
								sx={{ boxShadow: "none", "&:before": { display: "none" }, border: "1px solid #e0e0e0" }}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									sx={{ "& .MuiAccordionSummary-content": { alignItems: "center" } }}
								>
									<Checkbox
										checked={selectedDocTypes.length === availableDocTypes.length}
										indeterminate={selectedDocTypes.length > 0 && selectedDocTypes.length < availableDocTypes.length}
										onChange={(e) => {
											e.stopPropagation();
											handleToggleAllDocTypes(e.target.checked);
										}}
										onClick={(e) => e.stopPropagation()}
									/>
									<Typography fontWeight="bold">
										Tipi di Documento ({selectedDocTypes.length}/{availableDocTypes.length})
									</Typography>
								</AccordionSummary>
								<AccordionDetails sx={{ pt: 0 }}>
									<Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", ml: 4 }}>
										{availableDocTypes.map((docType) => (
											<FormControlLabel
												key={docType.id}
												control={
													<Checkbox
														size="small"
														checked={selectedDocTypes.includes(docType.id)}
														onChange={(e) => handleToggleDocType(docType.id, e.target.checked)}
													/>
												}
												label={<Typography variant="body2">{docType.name}</Typography>}
												sx={{ mr: 2 }}
											/>
										))}
									</Box>
								</AccordionDetails>
							</Accordion>
						</Box>

						{/* Operators Section */}
						<Box sx={{ p: 2 }}>
							<Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
								Operatori ({operatorsWithDocuments.length})
							</Typography>
							<FormControlLabel
								sx={{ display: "flex", alignItems: "center" }}
								control={
									<Checkbox
										checked={Object.values(selectedOperators).every((op) => op.selected)}
										indeterminate={
											Object.values(selectedOperators).some((op) => op.selected) &&
											!Object.values(selectedOperators).every((op) => op.selected)
										}
										onChange={(e) => handleToggleAllOperators(e.target.checked)}
									/>
								}
								label={<Typography fontWeight="medium">Seleziona Tutti</Typography>}
							/>

							<Box sx={{ maxHeight: "40vh", overflowY: "auto", mt: 1 }}>
								{operatorsWithDocuments.map((operator) => {
									const operatorData = selectedOperators[operator.id] || { selected: false, documents: [] };
									const operatorDocs = availableDocTypes.filter((docType) => {
										const status = operator[getStatusKey(docType.id)];
										return status && status !== "toUpload";
									});

									return (
										<Accordion
											key={operator.id}
											expanded={expandedOperator === operator.id}
											onChange={(_, expanded) => setExpandedOperator(expanded ? operator.id : null)}
											sx={{ "&:before": { display: "none" }, boxShadow: "none", border: "1px solid #e0e0e0", mb: 1 }}
										>
											<AccordionSummary
												expandIcon={<ExpandMoreIcon />}
												sx={{ "& .MuiAccordionSummary-content": { alignItems: "center" } }}
											>
												<Checkbox
													checked={operatorData.selected}
													indeterminate={
														operatorData.documents.length > 0 &&
														operatorData.documents.length < operatorDocs.length
													}
													onChange={(e) => {
														e.stopPropagation();
														handleToggleOperator(operator.id.toString(), e.target.checked);
													}}
													onClick={(e) => e.stopPropagation()}
												/>
												<Typography>
													{operator.name}
													<Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>
														({operatorData.documents.length}/{operatorDocs.length} documenti)
													</Typography>
												</Typography>
											</AccordionSummary>
											<AccordionDetails sx={{ pt: 0 }}>
												<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, ml: 4 }}>
													{operatorDocs.map((docType) => (
														<FormControlLabel
															key={docType.id}
															control={
																<Checkbox
																	size="small"
																	checked={operatorData.documents.includes(docType.id)}
																	disabled={!selectedDocTypes.includes(docType.id)}
																	onChange={(e) =>
																		handleToggleOperatorDoc(
																			operator.id.toString(),
																			docType.id,
																			e.target.checked
																		)
																	}
																/>
															}
															label={
																<Typography
																	variant="body2"
																	color={
																		!selectedDocTypes.includes(docType.id) ? "text.disabled" : "inherit"
																	}
																>
																	{docType.name}
																</Typography>
															}
														/>
													))}
												</Box>
											</AccordionDetails>
										</Accordion>
									);
								})}
							</Box>
						</Box>
					</DialogContent>
					<DialogActions sx={{ borderTop: "1px solid #e0e0e0", p: 2 }}>
						<Typography variant="body2" color="text.secondary" sx={{ mr: "auto" }}>
							{totalSelectedDocs} documenti selezionati
						</Typography>
						<Button onClick={() => setDownloadDialogOpen(false)} color="inherit">
							Annulla
						</Button>
						<Button
							variant="contained"
							onClick={handleDownloadWithSelection}
							disabled={totalSelectedDocs === 0}
							startIcon={<DownloadIcon />}
							sx={{
								backgroundColor: "#514f4f",
								"&:hover": { backgroundColor: "#3d3b3b" },
								"&:disabled": { backgroundColor: "#7a7777" },
							}}
						>
							Scarica Selezionati
						</Button>
					</DialogActions>
				</Dialog>
			</DashboardLayout>
		</>
	);
}

// Helper functions

function getStatusColor(status, required) {
	switch (status.toLowerCase()) {
		case "approved":
			return "success";
		case "rejecteddone":
			return "info";
		case "toapprove":
			return "warning";
		case "toupload":
			if (required) {
				return "error";
			}
			return "secondary";
		case "rejected":
			return "error";
		default:
			return "default";
	}
}

function getStatusName(status) {
	switch (status.toLowerCase()) {
		case "approved":
			return "Approvato";
		case "rejecteddone":
			return "Rettificato";
		case "toapprove":
			return "In attesa";
		case "toupload":
			return "Da caricare";
		case "rejected":
			return "Da rettificare";
		default:
			return "default";
	}
}

export default ManagementSecuritySupplierUser;
